import { axiosInstance } from "@/config/axiosInstance";
import type { DaySummary } from "@/components/break/types";

//  ****** GET CURRENT EMPLOYEE ******
export const getCurrentEmployee = (empKey: string) =>
  axiosInstance
    .get<{
      success: boolean;
      foundEmployee?: {
        _id: string;
        email: string;
        name: string;
        phone: string;
        paidLeavesTotal: number;
        paidLeavesRemaining: number;
      };
      error?: string;
    }>("/employee/current", {
      headers: {
        authorization: `Bearer ${empKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET EMPLOYEE CHECKINS ******
export const getCurrentEmployeeCheckins = (employeeKey: string) =>
  axiosInstance
    .get<{
      success: boolean;
      error?: string;
      checkins?: {
        mode: string;
        createdAtIST: string | Date;
        createdAt: string | Date;
        _id: string;
        employee: {
          name: string;
          email: string;
        };
      }[];
    }>(`/employee/checkins`, {
      headers: {
        authorization: `Bearer ${employeeKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL LEAVE APPLICATIONS of CURRENT EMPLOYEE ******
export const getAllLeaveApplicationsOfCurrentEmployee = (employeeKey: string) =>
  axiosInstance
    .get<{
      success: boolean;
      error?: string;
      LeaveApplication?: {
        _id: string;
        leaveType: string;
        reason: string;
        startDate: string | Date;
        endDate: string | Date;
        status: string;
        employee: {
          name: string;
          email: string;
        };
        createdAt: Date | string;
      }[];
    }>(`/leave/employee/fetch/all`, {
      headers: {
        authorization: `Bearer ${employeeKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET Single Loan Request ******
export const getSingleLeaveApplicationForEmployee =
  (employeeKey: string) => (leaveId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        error?: string;
        leave?: {
          _id: string;
          leaveType: string;
          reason: string;
          startDate: string | Date;
          endDate: string | Date;
          status: string;
          employee: {
            name: string;
            email: string;
          };
          attachment?: string;
          isPaid: boolean;
          isHalfDay: boolean;
          createdAt: Date | string;
        };
      }>(`/leave/one/employee/${leaveId}`, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL LEAVE APPLICATIONS of OTHER EMPLOYEES AS APPROVER ******
export const getAllLeaveApplicationsOfOtherEmployeesAsApprover = (
  employeeKey: string,
  status?: string
) =>
  axiosInstance
    .post<{
      success: boolean;
      error?: string;
      LeaveApplication?: {
        _id: string;
        leaveType: string;
        reason: string;
        startDate: string | Date;
        endDate: string | Date;
        status: string;
        attachment: string;
        isPaid: boolean;
        employee: {
          name: string;
          email: string;
        };
        createdAt: Date | string;
      }[];
    }>(
      `/leave/approver/fetch/all`,
      {
        status,
      },
      {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

//  ****** GET ALL ALLOWANCE REQUESTS of OTHER EMPLOYEES AS APPROVER ******
export const getAllAllowanceRequestsOfOtherEmployeesAsApprover = (
  employeeKey: string,
  status?: string
) =>
  axiosInstance
    .post<{
      success: boolean;
      error?: string;
      allowances?: {
        _id: string;
        reason: string;
        amountRequested: number;
        attachment: string;
        employee: {
          name: string;
          email: string;
        };
        status: string;
        createdAt: Date | string;
      }[];
    }>(
      `/allowance/approver/fetch/all`,
      {
        status,
      },
      {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((response) => response.data);

//  ****** GET ALL LEADS ******
export const fetchAllLeads =
  (key: string) =>
  (data: { startdate: Date; enddate: Date; status?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        leads: {
          name: string;
          phone: string;
          status: string;
          originalStatus: string;
          _id: string;
          broker: string;
          alloted: boolean;
          createdAt: string | Date;
          allotedAt?: string | Date;
          allotedTo?: {
            name: string;
            email: string;
            _id: string;
          };
        }[];
      }>(`/lead/fetch`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET DATEWISE LEADS ******
export const fetchLeadsDateWiseForEmployee =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        reports: {
          alloted: number;
          attempted: number;
          open: number;
          closed: {
            success: number;
            failed: number;
          };
        };
      }>(`/lead/fetch-reports/employee`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL LEADS ******
export const fetchAllLeadRemindersOfEmployee = (key: string) =>
  axiosInstance
    .get<{
      success: boolean;
      triggers: {
        _id: string;
        comments: string;
        disabled: boolean;
        triggered: boolean;
        lead: {
          _id: string;
          name: string;
          broker: string;
          originalStatus: string;
          status: string;
          phone: string;
        };
        createdAt: string;
      }[];
    }>(`/lead/trigger/fetch`, {
      headers: {
        authorization: `Bearer ${key}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL Allowance Requests Action ******
export const getAllAllowanceRequestsOfEmployees =
  (employeeKey: string) => (status?: string) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        Allowances?: {
          _id: string;
          reason: string;
          amountRequested: number;
          status: string;
          employee: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
        }[];
      }>(
        `/allowance/employee/fetch/all`,
        { status },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET ALL Loan Requests ******
export const getAllLoanRequestsForEmployee =
  (employeeKey: string) => (status?: string) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        loans?: {
          _id: string;
          totalAmountRequested: number;
          status: string;
          employeeId: {
            name: string;
            email: string;
          };
          createdAt: Date | string;
          createdAtIST: Date | string;
        }[];
      }>(
        `/loan/employee/fetch/all`,
        { status },
        {
          headers: {
            authorization: `Bearer ${employeeKey}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET Single Loan Request ******
export const getSingleLoanRequestForEmployee =
  (employeeKey: string) => (loanId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        loan: {
          _id: string;
          status: string;
          employeeId: {
            name: string;
            email: string;
          };
          interestRate?: number;
          totalAmountRequested?: number;
          totalAmountApproved?: number;
          totalRepaymentAmount?: number;
          remainingBalance?: number;
          repaymentSchedule?: {
            _id: string;
            amount: number;
            createdAt: string | Date;
            dueDate: string | Date;
            paidAmount: number;
            status: string;
          }[];
        };
      }>(`/loan/employee/one/${loanId}`, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Loan Repayment Requests of Employee ******
export const getLoanRepaymentRequestsOfEmployee =
  (employeeKey: string) => (loanId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        requests: {
          _id: string;
          status: string;
          employeeId: {
            name: string;
            email: string;
          };
          attachment: string;
          amount: number;
          createdAt: string | Date;
          createdAtIST: string | Date;
        }[];
      }>(`/loan/employee/requests/${loanId}`, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Employee Attendance ******
export const getAttendanceForEmployee =
  (employeeKey: string) => (dates: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        attendance?: {
          _id: string;
          createdAt: Date | string;
          status: string;
          date: string | Date;
          checkin: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
          checkout: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
        }[];
      }>(`/attendance/fetch/employee`, dates, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Employee Attendance ******
export const getAttendanceByMonthYearForEmployee =
  (employeeKey: string) => (data: { monthName: string; year: number }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        attendance?: {
          _id: string;
          createdAt: Date | string;
          status: string;
          date: string | Date;
          checkin: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
          checkout: {
            _id: string;
            createdAt: string | Date;
            mode: string;
            employee: string;
          }[];
        }[];
      }>(`/attendance/fetch/employee/month`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ATTENDANCE REQUESTS ******
export const fetchAllAttendanceRequestsForEmployee =
  (key: string) =>
  (data: { startdate: Date; enddate: Date; status?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        requests: {
          notes: string;
          status: string;
          _id: string;
          createdAt: string | Date;
          date: string | Date;
        }[];
      }>(`/attendance/request/all/employee`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL Timesheets By Year For Admin ******
export const fetchAllTimesheetsByYearForEmployee =
  (key: string) => (data: { year: number }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        sheets: {
          _id: string;
          month: string;
          year: number;
          present: number;
          absent: number;
          paidLeave: number;
          unpaidLeave: number;
          createdAt: string | Date;
          salaryGenerated: boolean;
          employee: {
            _id: string;
            name: string;
          };
        }[];
      }>(`/salary/fetch-datesheet-employee-year`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL PERFORMANCE LOGS OF A EMPLOYEE ******
export const fetchAllPerformanceLogsOfEmployeeForEmployee =
  (key: string) => (data: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        log: {
          _id: string;
          reasonPositive: string;
          reasonNegative: string;
          deduction: number;
          addition: number;
          createdAt: string | Date;
          date: string | Date;
        }[];
      }>(`/performance/logs/employee/all`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Single Lead log ******
export const fetchSingleLeadLogForEmployee =
  (key: string) => (leadId: string) =>
    axiosInstance
      .get<{
        success: boolean;
        error?: string;
        logs: {
          _id: string;
          beforeStatus: string;
          comments: string;
          afterStatus: string;
          createdAt: string | Date;
        }[];
      }>(`/lead/admin/logs/${leadId}`, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL ANNOUNCEMENTS ******
export const getAllAnnouncementsForEmployee =
  (employeeKey: string) => (dates: { startdate: Date; enddate: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        announcements: {
          createdAt: string;
          description: string;
          files: string[];
          title: string;
          _id: string;
        }[];
      }>(`/announcement/employee/get/all`, dates, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET ALL SALARY OF A EMPLOYEE ******
export const fetchAllSalaryOfEmployeeForEmployee =
  (key: string) => (data: { start: Date; end: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        salary: {
          _id: string;
          approved: boolean;
          employee: {
            _id: string;
            name: string;
            email: string;
          };
          createdAt: string | Date;
          netPay: number;
          totalDeductions: number;
          totalEarnings: number;
          notes: string;
          month: string;
          year: number;
          daysInMonth: number;
          daysPayable: number;
          period: {
            start: string | Date;
            end: string | Date;
          };
          components: {
            type: string;
            name: string;
            amount: number;
            _id: string;
            description: string;
          }[];
        }[];
      }>(
        `/salary/fetch/employee`,
        {
          period: data,
        },
        {
          headers: {
            authorization: `Bearer ${key}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => response.data);

//  ****** GET ALL SALARY OF A EMPLOYEE ******
export const getAllSalaryOfEmployeeForEmployee = (key: string) =>
  axiosInstance
    .get<{
      success: boolean;
      salary: {
        _id: string;
        approved: boolean;
        employee: {
          _id: string;
          name: string;
          email: string;
        };
        createdAt: string | Date;
        netPay: number;
        totalDeductions: number;
        totalEarnings: number;
        notes: string;
        month: string;
        year: number;
        daysInMonth: number;
        daysPayable: number;
        period: {
          start: string | Date;
          end: string | Date;
        };
        components: {
          type: string;
          name: string;
          amount: number;
          _id: string;
          description: string;
        }[];
      }[];
    }>(`/salary/fetch/employee-direct`, {
      headers: {
        authorization: `Bearer ${key}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);

//  ****** GET ALL PERFORMANCE REPORTS FOR EMPLOYEE ******
export const fetchAllPerformanceReportsForEmployee =
  (adminKey: string) => (data: { year: number; month?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        remaining: number;
        performanceReports: {
          month: string;
          year: number;
          remainingPoints: number;
          totalPoints: number;
          _id: string;
        }[];
      }>(`/performance/report/employee/all-month`, data, {
        headers: {
          authorization: `Bearer ${adminKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET AVERAGE SCORE OF A EMPLOYEE ******
export const fetchAggregatePerformancePointsAsEmployee =
  (key: string) => (data: { month?: string }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        aggregate: number;
        average: number;
      }>(`/performance/report/calculate-aggregate/employee`, data, {
        headers: {
          authorization: `Bearer ${key}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET Employees Checkins ******
export const getCheckinsOfEmployeesDayWise =
  (employeeKey: string) => (data: { date: Date }) =>
    axiosInstance
      .post<{
        success: boolean;
        error?: string;
        checkins?: {
          _id: string;
          createdAt: Date | string;
          employee: {
            name: string;
            _id: string;
          };
          mode: string;
          isLate?: boolean;
        }[];
      }>(`/attendance/fetch/employee/checkins`, data, {
        headers: {
          authorization: `Bearer ${employeeKey}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data);

//  ****** GET TODAY'S BREAK STATUS (employee id comes from the token) ******
export const getTodayBreakStatus = (employeeKey: string) =>
  axiosInstance
    .get<{ success: boolean; error?: string } & DaySummary>(`/break/today`, {
      headers: {
        authorization: `Bearer ${employeeKey}`,
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data);
